import { useCallback } from 'react';
import { authService } from '../services/authService';
import { useAuthStore } from '../store/authStore';
import { RegisterFormState } from '../utils/registerValidation';
import { unmaskPhone } from '../utils/phone';

export function useRegisterAccount() {
  const login = useAuthStore((s) => s.login);

  return useCallback(
    async (form: RegisterFormState): Promise<void> => {
      const data = await authService.register({
        ...form,
        name: form.name.trim(),
        email: form.email.trim(),
        phone: unmaskPhone(form.phone),
      });
      login(data.accessToken, data.customerId, data.name, data.canManageStoreSettings);
    },
    [login]
  );
}
